var _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.78,395s1.17-5.9,5.75-7.17,6.35-2.67,6.35-2.67S237.47,394.27,226.78,395Z",
    style: {
      fill: "#B5D0FF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.35 225.94 420.35 382.41 388.27 382.41 388.27 246.44 420.35 225.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.13 274.06 393.38 382.21 401.23 382.21 446.85 382.21 454.7 382.21 455.05 274.06 393.13 274.06",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.1 260.29 405.13 284.41 409.99 284.41 438.22 284.41 443.08 284.41 443.13 260.29 405.1 260.29",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.06 284.41 397.04 284.41 397.02 277.18 405.05 277.18 405.06 284.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.42,
    y: 277.18,
    width: 8.02,
    height: 7.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.8,
    y: 277.18,
    width: 8.02,
    height: 7.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.2 284.41 443.18 284.41 443.2 277.18 451.22 277.18 451.2 284.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.95 297.57 397.12 297.57 397.1 290.52 404.94 290.52 404.95 297.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.47,
    y: 290.52,
    width: 7.84,
    height: 7.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.84,
    y: 290.52,
    width: 7.84,
    height: 7.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.03 297.57 443.2 297.57 443.21 290.52 451.05 290.52 451.03 297.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.88 310.42 397.23 310.42 397.22 303.54 404.87 303.54 404.88 310.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.57,
    y: 303.54,
    width: 7.65,
    height: 6.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.92,
    y: 303.54,
    width: 7.65,
    height: 6.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.22,
    y: 266.69,
    width: 8.18,
    height: 7.37,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.61,
    y: 266.69,
    width: 8.18,
    height: 7.37,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.91 310.42 443.26 310.42 443.27 303.54 450.93 303.54 450.91 310.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.86 322.95 397.38 322.95 397.37 316.24 404.85 316.24 404.86 322.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.71,
    y: 316.24,
    width: 7.48,
    height: 6.71,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.04,
    y: 316.24,
    width: 7.48,
    height: 6.71,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.85 322.95 443.37 322.95 443.39 316.24 450.86 316.24 450.85 322.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.2 337.05 396.86 337.05 396.85 329.58 405.19 329.58 405.2 337.05",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.49 337.05 412.16 337.05 412.15 329.58 420.5 329.58 420.49 337.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.79 337.05 427.46 337.05 427.46 329.58 435.8 329.58 435.79 337.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.09 337.05 442.76 337.05 442.77 329.58 451.11 329.58 451.09 337.05",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.24 348.96 397.1 348.96 397.08 341.66 405.23 341.66 405.24 348.96",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.39,
    y: 341.66,
    width: 8.14,
    height: 7.29,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.69,
    y: 341.66,
    width: 8.14,
    height: 7.29,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.12 348.96 442.98 348.96 442.99 341.66 451.14 341.66 451.12 348.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.07 362.35 397.13 362.35 397.12 355.25 405.06 355.25 405.07 362.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.39,
    y: 355.25,
    width: 7.94,
    height: 7.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.66,
    y: 355.25,
    width: 7.94,
    height: 7.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.86 362.35 442.92 362.35 442.94 355.25 450.88 355.25 450.86 362.35",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.07 374.54 397.32 374.54 397.31 367.61 405.06 367.61 405.07 374.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.83 374.54 443.08 374.54 443.1 367.61 450.86 367.61 450.83 374.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.64 367.61 412.5 367.61 412.54 369.35 413.19 369.35 413.19 382.21 415.51 382.21 415.5 369.35 432.68 369.35 432.66 382.21 434.97 382.21 434.99 369.35 435.69 369.35 435.64 367.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.19 382.21 415.61 382.21 415.61 369.35 424.2 369.35 424.19 382.21",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.55 382.21 423.98 382.21 423.98 369.35 432.57 369.35 432.55 382.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.47 274.06 274.24 382.21 282.09 382.21 327.71 382.21 335.56 382.21 334.39 274.06 272.47 274.06",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.34 277.18 276.55 290.34 276.61 293.96 276.67 297.57 284.7 297.57 284.64 293.96 284.59 290.34 284.38 277.18 276.34 277.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 277.18 291.92 290.34 291.98 293.96 292.03 297.57 300.06 297.57 300.01 293.96 299.96 290.34 299.78 277.18 291.73 277.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.12 277.18 307.3 290.34 307.34 293.96 307.39 297.57 315.42 297.57 315.38 293.96 315.33 290.34 315.17 277.18 307.12 277.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.51 277.18 322.67 290.34 322.74 295.93 322.75 297.57 330.79 297.57 330.77 295.93 330.71 290.34 330.56 277.18 322.51 277.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.82 303.54 277.04 316.69 277.09 320.3 277.15 323.91 285.2 323.91 285.14 320.3 285.09 316.69 284.88 303.54 276.82 303.54",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.17 303.54 292.37 316.69 292.44 321.78 292.47 323.91 300.52 323.91 300.49 321.78 300.42 316.69 300.23 303.54 292.17 303.54",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.52 303.54 307.69 316.69 307.74 320.3 307.79 323.91 315.84 323.91 315.79 320.3 315.75 316.69 315.58 303.54 307.52 303.54",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.87 303.54 323.02 316.69 323.07 320.3 323.11 323.91 331.15 323.91 331.12 320.3 331.08 316.69 330.93 303.54 322.87 303.54",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.28 329.58 277.49 342.67 277.55 346.27 277.61 349.86 285.64 349.86 285.58 346.27 285.53 342.67 285.33 329.58 277.28 329.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.59 329.58 292.78 342.67 292.83 346.27 292.89 349.86 300.92 349.86 300.87 346.27 300.82 342.67 300.64 329.58 292.59 329.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.9 329.58 308.07 342.67 308.12 346.27 308.17 349.86 316.2 349.86 316.15 346.27 316.11 342.67 315.95 329.58 307.9 329.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.21 329.58 323.36 342.67 323.42 347.64 323.45 349.86 331.48 349.86 331.45 347.64 331.4 342.67 331.26 329.58 323.21 329.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.67 355.25 323.7 355.25 316.26 355.25 308.31 355.25 300.87 355.25 292.92 355.25 277.53 355.25 277.65 362.35 293.03 362.35 300.97 362.35 308.4 362.35 316.34 362.35 323.78 362.35 327.75 362.35 331.72 362.35 331.64 355.25 327.67 355.25",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.25 367.61 293.11 367.61 293.08 369.35 293.78 369.35 293.97 382.21 296.29 382.21 296.1 369.35 313.27 369.35 313.44 382.21 315.75 382.21 315.59 369.35 316.23 369.35 316.25 367.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.96 382.21 296.39 382.21 296.2 369.35 304.79 369.35 304.96 382.21",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.33 382.21 304.75 382.21 304.58 369.35 313.17 369.35 313.33 382.21",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.79 280.29 393.49 382.21 386.09 382.21 343.1 382.21 335.71 382.21 334.44 280.29 392.79 280.29",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.18 357.04 375.33 357.04 389.47 357.04 389.5 360.3 389.52 363.56 389.61 375.4 382.29 375.4 382.19 363.23 375.04 363.23 372.23 363.23 368.11 363.23 368.06 357.04 372.18 357.04",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.28 357.04 347.1 357.04 360.52 357.04 360.59 363.23 346.7 363.23 346.83 375.4 339.52 375.4 339.38 363.56 339.32 358.84 339.3 357.04 344.28 357.04",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.5 368.48 374.42 368.48 374.43 370.22 374.65 370.22 374.75 382.21 372.6 382.21 372.49 370.22 356.48 370.22 356.6 382.21 354.44 382.21 354.32 370.22 354.52 370.22 354.5 368.48",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.51 382.21 372.51 382.21 372.41 370.22 364.4 370.22 364.51 382.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.69 382.21 364.68 382.21 364.57 370.22 356.56 370.22 356.69 382.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.01 284.41 389.21 284.41 389.35 303.54 367.19 303.54 367.01 284.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.23 284.41 360.43 284.41 360.61 303.54 338.46 303.54 338.23 284.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.63 308.46 388.88 308.46 389.01 326.75 367.79 326.75 367.63 308.46",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.89 308.46 360.14 308.46 360.33 326.75 339.11 326.75 338.89 308.46",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.84 333.33 389.21 333.33 389.35 351.66 368.01 351.66 367.84 333.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.2 333.33 360.57 333.33 360.75 351.66 339.41 351.66 339.2 333.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.81 234.66 244.81 225.12 254.91 225.12 254.91 198.69 258.21 198.69 258.21 225.12 268.31 225.12 268.31 234.66 273.08 234.66 273.08 382.66 240.04 382.66 240.04 234.66 244.81 234.66",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,267V382.76H84.6v-107L77.44,267ZM74.58,350h6.75v6.75H74.58Zm0-13.5h6.75v6.75H74.58Zm0-27h6.75v6.75H74.58Zm0-13.5h6.75v6.75H74.58Zm0-13.5h6.75v6.75H74.58Zm-13.5,54h6.75v6.75H61.08Zm0-13.5h6.75v6.75H61.08Zm0-13.5h6.75v6.75H61.08ZM47.58,350h6.75v6.75H47.58Zm0-27h6.75v6.75H47.58Zm0-13.5h6.75v6.75H47.58Zm0-27h6.75v6.75H47.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.25,
    y: 305.58,
    width: 4.27,
    height: 25.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.81 331.14 143.19 331.14 128.52 331.14 128.52 305.58 129.13 305.58 131.88 305.58 135.48 305.58 157.9 305.58 164.26 305.58 164.26 331.14 159.81 331.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.71,
    y: 305.58,
    width: 6.75,
    height: 1.22,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.99,
    y: 305.58,
    width: 6.56,
    height: 1.22,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.54,315.14h-1.69a.54.54,0,0,0,0,1.07h1.66v5h-1.66a.54.54,0,0,0,0,1.07h1.66v8.83h-6.33V305.58h9.67v2.17A11,11,0,0,0,213.54,315.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.51,
    y: 331.44,
    width: 11.51,
    height: 52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 382.69,
    width: 5.97,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.85,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.8,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.15,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.45,
    y: 382.69,
    width: 5.97,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.55,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.2,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.24,
    y: 382.69,
    width: 5.98,
    height: 0.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,331.14v52h25.71v-.44H109.6v-39.2h-4.25a1.07,1.07,0,0,1,0-2.14h4.25v-6.53H237.79v-3.68h-2.08v.21h-22.2v-.21h-6.33v1.16H164.26v-1.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6,341.35v-6.52h6.31v6.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,382.69H109.6v-39.2h6.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,343.49v39.2h5.82v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.38,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.38,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.38,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.38,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h6v-8.41a2.69,2.69,0,0,1,5.37,0v8.41h5.81v-39.2Zm119.32,19.39a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.36,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.35,0a2.69,2.69,0,1,1,5.38,0v3.79h-5.38Zm-11.35,0a2.69,2.69,0,1,1,5.38,0v3.79h-5.38Zm-11.35,0a2.69,2.69,0,0,1,5.38,0v3.79h-5.38Zm-11.34,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.35,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.35,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.36,0a2.69,2.69,0,1,1,5.38,0v3.79h-5.38Zm-11.34,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Zm-11.35,0a2.69,2.69,0,1,1,5.37,0v3.79h-5.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.71,341.35H115.91v-6.52h130.5v6.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.29,343.49H105.35a1.07,1.07,0,0,1,0-2.14H249.66a1.07,1.07,0,0,1,0,2.14H123.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,245.66v-3.8a.87.87,0,0,1,1.73,0v3.8a8.11,8.11,0,0,0-.86,0A8.3,8.3,0,0,0,152.66,245.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,254.05v9.71a17.91,17.91,0,0,1,14.8,0v-9.71Zm5.08,3.14a2.32,2.32,0,1,1,4.64,0v3.28h-4.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,245.66a8.3,8.3,0,0,1,.87,0,8.11,8.11,0,0,1,.86,0,7.39,7.39,0,0,1,6.5,6.66H146.16A7.4,7.4,0,0,1,152.66,245.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,279.23a17.93,17.93,0,0,1,31.72-10.59l-3.06,10.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,254.05a.87.87,0,0,1,0-1.73h19.73a.87.87,0,0,1,0,1.73H143.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,281v8.13h28.67v-1.26H163v-3.28a2.32,2.32,0,0,1,1.29-2.07V281Zm19.54,3.59a2.32,2.32,0,0,1,4.64,0v3.28h-4.64Zm-7.85,0a2.33,2.33,0,0,1,4.65,0v3.28h-4.65Zm-7.85,0a2.33,2.33,0,0,1,4.65,0v3.28h-4.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,290.83v14.6h3.84V295.09a2.33,2.33,0,1,1,4.65,0v10.34h3.2V295.09a2.33,2.33,0,1,1,4.65,0v10.34h3.2V295.09a2.32,2.32,0,1,1,4.64,0v10.34H163v-8.82h-.14a1.07,1.07,0,0,1,0-2.14h.23a2.32,2.32,0,0,1,1.2-1.45v-2.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,280.14v0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,279.26V281H132.9a.87.87,0,0,1,0-1.73h31.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,290v0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,290.83H132.9a.87.87,0,0,1,0-1.74h31.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,306.79V332.3h21.46V306.79H189.7v-3.08a4.07,4.07,0,1,0-8.14,0v3.08Zm8.5-2.29a2.15,2.15,0,1,1,4.29,0v7.07h-4.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,279.26v15.21h10.73V279.26l-5.36-18.6Zm3.09,7.64a2.28,2.28,0,0,1,4.56,0v7.51h-4.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,296.61V332.3h10.73V296.61Zm3.09,25.23a2.28,2.28,0,0,1,4.56,0v7.52h-4.56Zm0-15.07a2.28,2.28,0,0,1,4.56,0v7.51h-4.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,296.61a1.07,1.07,0,0,1,0-2.14h13.59a1.07,1.07,0,0,1,0,2.14H195Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,279.26v15.21H175V279.26l-5.36-18.6-2.3,8-3.06,10.59Zm3.09,7.64a2.28,2.28,0,0,1,4.56,0v7.51h-4.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,296.61V332.3H175V296.61Zm3.09,25.23a2.28,2.28,0,0,1,4.56,0v7.52h-4.56Zm0-15.07a2.28,2.28,0,0,1,4.56,0v7.51h-4.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,296.61h13.59a1.07,1.07,0,0,0,0-2.14H162.83A1.07,1.07,0,0,0,162.83,296.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,294.37v.22a.54.54,0,0,0,1.08,0v-.22a4.59,4.59,0,0,1,4,4.12h-9.12A4.59,4.59,0,0,1,224.07,294.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,299.57v6a11.09,11.09,0,0,1,9.16,0v-6Zm3.14,1.94a1.44,1.44,0,1,1,2.87,0v2h-2.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.54,315.14a11.08,11.08,0,0,1,22.14,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.51,299.56a.54.54,0,0,1,0-1.07h12.2a.54.54,0,0,1,0,1.07h-12.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,316.21v5h22.2v-5Zm16.94,2.22a1.44,1.44,0,0,1,2.88,0v2h-2.88Zm-4.85,0a1.44,1.44,0,1,1,2.87,0v2H225.6Zm-4.85,0a1.44,1.44,0,1,1,2.87,0v2h-2.87Zm-4.86,0a1.44,1.44,0,1,1,2.88,0v2h-2.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,331.35v-9h22.2v9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,294.59V290.7a.54.54,0,0,1,1.08,0v3.89A.54.54,0,0,1,224.07,294.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,316.21h-1.66a.54.54,0,0,1,0-1.07h25.52a.54.54,0,0,1,0,1.07H213.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,322.31h-1.66a.54.54,0,0,1,0-1.07h25.52a.54.54,0,0,1,0,1.07H213.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,382.36l12.16-.15-.88-43.62-.17-10.11v-.61l-.16-9,0-.59-.14-8.55v-.56l-.14-8.17v-.52l-.13-7.78v-.51l-.13-7.42v-.49l-.12-7.11v-.46l-.11-6.17a4.21,4.21,0,0,1-1,.57l.07,4.49-4.19-3.82a10.68,10.68,0,0,1-1.58-.19l5.07,4.65-6.3,0,0-5a4.52,4.52,0,0,1-1-.46l0,5.89v.46l-.07,7.11v.47l-.07,7.45v.5l-.07,7.79V301l-.07,8.17v.56l-.09,8.57v.58l-.09,9v.61l-.1,10.12Zm1.92-53.57h7.27l-7.32,7.91Zm.12-8.49,7.19,7.55H95.59Zm-.09-10.73,6.92,0-7,7.14Zm.08-7.82,6.86,6.88-6.9,0Zm0-9.11,6.6,0-6.64,6.49Zm.06-7.22,6.54,6.26-6.59,0Zm6.38-8.17-6.35,5.9,0-5.93Zm.93,7.27-6.44,0,6.35-5.92Zm.1,7.21-6.53-6.23,6.44,0Zm.13,9-6.73,0,6.65-6.5Zm.1,7.79-6.85-6.84,6.75,0Zm.14,9.82H96.45l7-7.17Zm.07,8.47-7.2-7.53h7.1Zm.06,10.39H96.22l7.32-7.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92,271.13a4.51,4.51,0,0,0,1,.45v-.74l1.18,1.09a11,11,0,0,0,1.59.19l-2.91-2.66-.34.31h-.5Zm7.85-1.31,0,1.63a4,4,0,0,0,1-.57l0-1.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,269a1.69,1.69,0,0,0,.51,1.45l.34.32a5,5,0,0,0,.56.39,4.51,4.51,0,0,0,1,.45,7,7,0,0,0,1.18.35,11,11,0,0,0,1.59.19h.71a8.66,8.66,0,0,0,3.4-.69,4,4,0,0,0,1-.57l.08-.06.32-.31a1.57,1.57,0,0,0,.46-1.4l-.72-4.06,1.91,0-6.66-3.39-6.94,3.16,2,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,110.11c.17-1.84-1.44-3-3.79-3a7.2,7.2,0,0,0-6.05,3.32l-6.54-3.69c2.8-4.1,7.5-6.81,14.28-6.81,7.09,0,11.89,3,11.4,8.66-.63,7.18-8.28,8.24-8.65,12.48h-8.2C356.08,115.09,362.8,113.57,363.1,110.11Zm-9.29,18.34a5.33,5.33,0,0,1,5.62-4.75c3.08,0,5.07,2,4.83,4.75a5.48,5.48,0,0,1-5.67,4.83C355.5,133.28,353.57,131.12,353.81,128.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69,86.51c.11-1.31-1-2.1-2.7-2.1a5.12,5.12,0,0,0-4.3,2.36L144,84.15c2-2.91,5.33-4.85,10.15-4.85,5,0,8.45,2.17,8.1,6.16-.44,5.11-5.88,5.86-6.14,8.88h-5.83C150.69,90.05,155.47,89,155.69,86.51Zm-6.61,13a3.78,3.78,0,0,1,4-3.37c2.2,0,3.61,1.44,3.44,3.37a3.91,3.91,0,0,1-4,3.44A3.14,3.14,0,0,1,149.08,99.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--speech-bubbles--inject-120--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.09,92.58l41.18-.24a2.15,2.15,0,0,1,2.25,2.08,2,2,0,0,1,0,.35l-2,18.94a2.85,2.85,0,0,1-2.76,2.47l-23.54.19a18.64,18.64,0,0,1-10.86,6.34s3.95-3.62,4.88-6.31l-11.66,0a2.18,2.18,0,0,1-2.25-2.09,2.11,2.11,0,0,1,0-.35l2-18.94A2.87,2.87,0,0,1,231.09,92.58Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.17,104.92a2,2,0,1,1-2-2A2,2,0,0,1,243.17,104.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.44,104.92a2,2,0,1,1-2-2A2,2,0,0,1,252.44,104.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,104.92a2,2,0,1,1-2-2A2,2,0,0,1,261.7,104.92Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letters--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.46,213.35v34.24h59.92v34H95.46V335H57.07V179.33H163.52v34Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,305.39H192.83l-10.67,30.24H143L202.91,180h37.81l60.1,155.64H260.88ZM239,272.93l-17.45-49.81-17.45,49.81Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.65,351.62a45.56,45.56,0,0,1-38,19.56c-22.1,0-36.64-8.67-59.33-35.79-35.67-6.9-60.49-38.47-60.49-79.6,0-46.7,32-80.94,75.42-80.94s75.42,34.24,75.42,80.94c0,35.35-18.42,63.59-46.14,75.15,5.43,6.67,10.08,8.89,15.9,8.89,7.36,0,14.54-3.78,20.55-10.89Zm-82.4-51.37c20.55,0,36.64-17.56,36.64-44.46s-16.09-44.47-36.64-44.47-36.65,17.56-36.65,44.47S339.7,300.25,360.25,300.25Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.17,180.19a.5.5,0,0,1-.07-1,62.81,62.81,0,0,1,12.58-.44.5.5,0,0,1,.47.53.53.53,0,0,1-.54.47,61.43,61.43,0,0,0-12.37.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.52,209a.47.47,0,0,1-.3-.1.5.5,0,0,1-.1-.7c9.52-12.57,21.95-21.64,35.95-26.21a.49.49,0,0,1,.63.32.51.51,0,0,1-.32.63c-13.8,4.51-26.06,13.45-35.46,25.86A.51.51,0,0,1,304.52,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,184.75H86.27a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H93.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,93.8,184.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,209a.5.5,0,0,1-.5-.5V184.25a.5.5,0,0,1,.5-.5H79.73a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5H62.68v23.72A.5.5,0,0,1,62.18,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,184.75h-8.77a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h8.77a.51.51,0,0,1,.5.5A.5.5,0,0,1,237.34,184.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,211.82a.39.39,0,0,1-.18,0,.49.49,0,0,1-.29-.64l10.12-27.06a.51.51,0,0,1,.47-.33h14.1a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H206.06l-10,26.74A.49.49,0,0,1,195.59,211.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.78,395s1.17-5.9,5.75-7.17,6.35-2.67,6.35-2.67S237.47,394.27,226.78,395Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.78,395s1.17-5.9,5.75-7.17,6.35-2.67,6.35-2.67S237.47,394.27,226.78,395Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.92,395a.35.35,0,0,1-.22-.08.32.32,0,0,1,0-.46,22.7,22.7,0,0,1,8.47-5.89.33.33,0,0,1,.43.17.33.33,0,0,1-.18.43,22.12,22.12,0,0,0-8.23,5.72A.32.32,0,0,1,226.92,395Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.19,399.29s.35-9.4-6.15-13-8.71-6.35-8.71-6.35S211.18,394.32,227.19,399.29Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.19,399.29s.35-9.4-6.15-13-8.71-6.35-8.71-6.35S211.18,394.32,227.19,399.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.63,399a.31.31,0,0,1-.28-.17,40.7,40.7,0,0,0-12.09-13.14.33.33,0,0,1,.38-.54,41.44,41.44,0,0,1,12.28,13.36.33.33,0,0,1-.13.45A.42.42,0,0,1,226.63,399Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.69,402.77l-1-.19a62.13,62.13,0,0,0-.08-23.5l1-.19A63.1,63.1,0,0,1,226.69,402.77Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,371.6c.2,1.15,1.85,5.07,3,4.87s1.36-4.45,1.16-5.6a2.11,2.11,0,0,0-4.16.73Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,383.88c-.2-1.15-1.85-5.07-3-4.87s-1.36,4.45-1.16,5.6a2.11,2.11,0,0,0,4.16-.73Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,381c1.15-.2,5.07-1.85,4.87-3s-4.45-1.36-5.6-1.16a2.11,2.11,0,0,0,.73,4.16Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.79,374.52c-1.15.2-5.07,1.85-4.87,3s4.45,1.36,5.6,1.16a2.11,2.11,0,0,0-.73-4.16Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,375.67c1,.67,4.89,2.28,5.56,1.33s-2.18-4.11-3.13-4.78a2.11,2.11,0,1,0-2.43,3.45Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,379.81c-1-.67-4.89-2.28-5.56-1.33s2.18,4.11,3.13,4.78a2.11,2.11,0,0,0,2.43-3.45Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,384.36c.67-1,2.28-4.89,1.33-5.56s-4.11,2.18-4.78,3.13a2.11,2.11,0,0,0,3.45,2.43Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,371.12c-.67,1-2.28,4.89-1.33,5.56s4.11-2.18,4.78-3.13a2.11,2.11,0,1,0-3.45-2.43Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,378.17a2.5,2.5,0,1,0,2-2.89A2.5,2.5,0,0,0,224.19,378.17Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,378.17a2.5,2.5,0,1,0,2-2.89A2.5,2.5,0,0,0,224.19,378.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.38 414.97 218.56 414.97 215.3 401.78 235.65 401.78 232.38 414.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.83 412.82 232.83 416.48 230.12 416.48 230.12 415.79 227.58 415.79 227.58 416.48 222.98 416.48 222.98 415.79 220.43 415.79 220.43 416.48 218.03 416.48 218.03 412.82 232.83 412.82",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.8,291h5.07a121.61,121.61,0,0,0,.7-21.58c-.69-11.3,1.21-12-2.91-18.88a6.37,6.37,0,0,0-1.91-2.21,2.64,2.64,0,0,0-2.79-.15C368.14,248.67,370.88,275.72,370.8,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.8,291h5.07a121.61,121.61,0,0,0,.7-21.58c-.69-11.3,1.21-12-2.91-18.88a6.37,6.37,0,0,0-1.91-2.21,2.64,2.64,0,0,0-2.79-.15C368.14,248.67,370.88,275.72,370.8,291Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "405.6 344.93 407.9 356.8 413.65 356.66 412.55 344.1 405.6 344.93",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,356.63a.13.13,0,0,1-.09-.12.12.12,0,0,1,.07-.13c.09,0,2.15-1,3.07-.65a.71.71,0,0,1,.39.35.51.51,0,0,1,0,.58,2.43,2.43,0,0,1-1.69.28A9.89,9.89,0,0,1,414.14,356.63Zm.45-.14c1,.22,2.45.34,2.74,0,0-.05.09-.12,0-.3a.36.36,0,0,0-.24-.21.74.74,0,0,0-.25-.05A6.06,6.06,0,0,0,414.59,356.49Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.07,356.62a.19.19,0,0,1-.05-.13,3.85,3.85,0,0,1,1.07-2.09,1,1,0,0,1,.76-.17c.36.07.46.27.46.42.07.64-1.39,1.74-2.09,2h-.06A.14.14,0,0,1,414.07,356.62Zm1.67-2.14a.74.74,0,0,0-.48.12,3.15,3.15,0,0,0-.89,1.66c.73-.35,1.7-1.22,1.7-1.61,0,0,0-.13-.25-.17Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.64,355.79l-6.13-.54a.51.51,0,0,0-.52.34l-1.54,4.89a.82.82,0,0,0,.52,1l.17,0c2.22.16,4.19.21,6.94.46,3.25.29,2.39.61,6.2,1,2.3.23,3-2.34,2-2.56-4.41-1-4.76-2.34-6.34-4.09A2,2,0,0,0,413.64,355.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.07 352.51 413.21 351.65 412.55 344.1 405.6 344.93 407.07 352.51",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.13,284s36.21.08,37.94,10,4.22,55,4.22,55l-8.39,1.24s-5.92-24.94-9.65-50.43c0,0-38.39,3.4-40.4-1.94s-.43-13.38-.43-13.38Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.13,284s36.21.08,37.94,10,4.22,55,4.22,55l-8.39,1.24s-5.92-24.94-9.65-50.43c0,0-38.39,3.4-40.4-1.94s-.43-13.38-.43-13.38Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.09 351.37 415.37 349.9 415.22 346.2 404.23 347.51 405.09 351.37",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,297.32c0,.09,0,.18,0,.27a25.42,25.42,0,0,0-.27-3.64c-1.16-6.65-18.51-9.11-25.63-9.84l-8.65.26s-1.34,6.81.36,11.31S388.07,297.32,388.07,297.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,262.38l-2,16.28c.75,1.56,2.49,5.38,1.36,5.36-1.41,0-10.19,6-10.19,6l-15.85-6.33,1.09-4.47c-.32-1.41-1.75-9.74-3-17.07l-.11-.67-1.23-7.85-.44-2.81a0,0,0,0,1,0,0v0c-.13-1.21-.45-2.2-.55-2.86a1,1,0,0,1,0-.46,1.39,1.39,0,0,1,.5-.9l.06-.05.31-.24c5.77-4.17,20.72-.33,25.1.81.61.15,1.81.9,1.8,1.53l.77,2.26,1.63,4.8c.16.47.29.95.41,1.44A15.15,15.15,0,0,1,373.41,262.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.42 345.79 385.81 357.65 391.56 357.5 392.38 344.96 385.42 345.79",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.91,357.65a.12.12,0,0,1-.07-.13.15.15,0,0,1,.11-.12c.09,0,2.31-.49,3.13.05a.68.68,0,0,1,.3.42.5.5,0,0,1-.17.56,2.35,2.35,0,0,1-1.71-.1A9.28,9.28,0,0,1,391.91,357.65Zm.47,0c1,.45,2.31.87,2.67.6.05,0,.11-.09.07-.28a.36.36,0,0,0-.19-.26,1.28,1.28,0,0,0-.24-.11A6.19,6.19,0,0,0,392.38,357.61Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,357.62a.12.12,0,0,1,0-.13c0-.06.63-1.47,1.5-1.81a1,1,0,0,1,.77,0c.34.15.39.36.36.51-.08.64-1.74,1.39-2.47,1.47h-.06A.09.09,0,0,1,391.85,357.62Zm2.09-1.71a.69.69,0,0,0-.49,0,3.17,3.17,0,0,0-1.24,1.42c.79-.18,1.93-.82,2-1.19,0,0,0-.14-.2-.23Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,356.73l-5.86-1.88a.48.48,0,0,0-.57.22l-2.59,4.43a.81.81,0,0,0,.29,1.12l.15.08c2.13.64,4,1.12,6.67,2,3.1,1,2.2,1.12,5.83,2.34,2.19.73,3.39-1.64,2.5-2.06-4.09-1.91-4.12-3.34-5.28-5.39A2,2,0,0,0,391.6,356.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,285s32.17,2,33.9,12-3.8,53.59-3.8,53.59l-8.39.57s-1.81-29.52-1.62-48.32c0,0-34.36,2.1-36.37-3.23s-.42-14.06-.42-14.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,285s32.17,2,33.9,12-3.8,53.59-3.8,53.59l-8.39.57s-1.81-29.52-1.62-48.32c0,0-29.61,3.16-36.64-1.7-7.73-5.34.35-17.43.35-17.43Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,285s32.17,2,33.9,12-3.8,53.59-3.8,53.59l-8.39.57s-1.81-29.52-1.62-48.32c0,0-29.61,3.16-36.64-1.7-7.73-5.34.35-17.43.35-17.43Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.49 352.2 393.8 351.54 394.14 347.52 382.81 348.31 383.49 352.2",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,234.41c.4,3.27.7,8-1.71,10,2.93,2,2.21,4.74,4.3,7.57.31.41,4.2.17,4.61-.15.08-.06.72.11.77,0,2.82-4.32.35-6.73.35-6.73-1.88.93-1.82-2.36-1-4.82Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.81,243.73a9.88,9.88,0,0,1,.5-3.42L361,239.24,357,237C356.06,239.18,359.08,242.83,361.81,243.73Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,220.59c5.83,4.85,6.12,9,6.16,11.87a31.36,31.36,0,0,1-1.42,8.46c-3.26-2.27-5.93-5.48-6.66-9.38A14.29,14.29,0,0,1,365.88,220.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,226.77c-.92,5.34-1.42,7.6.6,10.88,3,5,9.79,5,12.28,0,2.23-4.46,3.41-12.44-1.28-15.75a7.39,7.39,0,0,0-11.6,4.85Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.44,231.71a11.94,11.94,0,0,0,.88,3.1,1.88,1.88,0,0,1-1.59-.08Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,236.67a4.62,4.62,0,0,0,.65.08.13.13,0,0,0,0-.25A3.51,3.51,0,0,1,363,235a.13.13,0,0,0-.23.13A3.67,3.67,0,0,0,365.13,236.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,227.18a.26.26,0,0,0,.3,0,3.08,3.08,0,0,1,2.45-.13.26.26,0,1,0,.18-.48,3.67,3.67,0,0,0-2.92.18.27.27,0,0,0-.07.36A.19.19,0,0,0,362.71,227.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,229.17a.26.26,0,0,0,.42-.28,2.56,2.56,0,0,0-1.64-1.7.25.25,0,0,0-.31.18.26.26,0,0,0,.18.32,2.08,2.08,0,0,1,1.28,1.37A.26.26,0,0,0,370,229.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,247.24s6.07,4.25,8.51.1l0,4-.05,4.83-.8,1.12-1.53-.5-1.79-3.33-.73-1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.63,244s6.71,9.31,8.42,12.21.57-11,.57-11,1-1.07,2.74.53c0,0,1.92,6.18,1.71,6.68s-2.49.71-2.49.71,1.32,1.54,1.06,2.42a5,5,0,0,1-2.71,2.48c-.8.1-6.15-2.55-6.44-3.3s1.37-1.82,1.37-1.82-3.84.15-4.37-1.25-2.55-7.71-2.55-7.71A1.74,1.74,0,0,1,353.63,244Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.63,244s6.71,9.31,8.42,12.21.57-11,.57-11,1-1.07,2.74.53c0,0,1.92,6.18,1.71,6.68s-2.49.71-2.49.71,1.32,1.54,1.06,2.42a5,5,0,0,1-2.71,2.48c-.8.1-6.15-2.55-6.44-3.3s1.37-1.82,1.37-1.82-3.84.15-4.37-1.25-2.55-7.71-2.55-7.71A1.74,1.74,0,0,1,353.63,244Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.86,230.63a4,4,0,0,0,1.55,2.6c1.12.82,2.18-.06,2.26-1.37s-.39-3-1.71-3.34a1.78,1.78,0,0,0-2.1,2.11Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.54,
    y: 232.42,
    width: 7.19,
    height: 16.92,
    rx: 1.73,
    transform: "translate(40.5 -55.33) rotate(8.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,248.44l2.64-1.57s1.05-3.38,2.15-3.72a30.25,30.25,0,0,1,2.61-1.66c1.38-.66,2.09.3,2.08,2.41s.76,3.34-1.31,4.33-3,1.37-3,1.37l-3.48,2.62Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,255.16a55,55,0,0,1-4.85,3.42,20.25,20.25,0,0,1-6.41,2.85l-1.23-7.85a3.77,3.77,0,0,1-.43-.64l0-2.2V250Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,252.32l-1.22.78c-2.41,1.51-4.53,2.79-6.65,4a77.49,77.49,0,0,1-10.86,4.85c-3.74-1.11-7.52-1.81-11.09-3.32-.2-.09-.41-.17-.61-.27a26.38,26.38,0,0,1-4.83-2.59,10.15,10.15,0,0,1-2.2-2.14,3.77,3.77,0,0,1-.43-.64,6.23,6.23,0,0,1-.71-1.47,5.66,5.66,0,0,1,.15-4.07,4,4,0,0,1,.56-1,1.67,1.67,0,0,1,.12-.16l.19-.08c4.4-2,7.14-.52,9.46,2.72,3.06.92,6,3.12,10.6,3.11a23.2,23.2,0,0,0,7.61-1.23c1.61-.53,3.46-1.25,5.78-2.25l1.7-.74.4.49a14.1,14.1,0,0,1,1.93,3.54A2,2,0,0,1,381,252.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,252.32l-1.22.78c-2.41,1.51-4.53,2.79-6.65,4a77.49,77.49,0,0,1-10.86,4.85c-3.74-1.11-7.52-1.81-11.09-3.32-.2-.09-.41-.17-.61-.27a26.38,26.38,0,0,1-4.83-2.59,10.15,10.15,0,0,1-2.2-2.14,3.77,3.77,0,0,1-.43-.64,6.23,6.23,0,0,1-.71-1.47,5.66,5.66,0,0,1,.15-4.07,4,4,0,0,1,.56-1,1.67,1.67,0,0,1,.12-.16l.19-.08c4.4-2,7.14-.52,9.46,2.72,3.06.92,6,3.12,10.6,3.11a23.2,23.2,0,0,0,7.61-1.23c1.61-.53,3.46-1.25,5.78-2.25l1.7-.74.4.49a14.1,14.1,0,0,1,1.93,3.54A2,2,0,0,1,381,252.32Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.07 252.5 380.56 254.36 376.7 248.3 378.63 246.87 382.07 252.5",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.07 252.5 380.56 254.36 376.7 248.3 378.63 246.87 382.07 252.5",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,219.33c-3.59-2.78-9.49.08-12.08,3.82A10.64,10.64,0,0,0,352,235.8c1.7,1.95,4.27,2.71,6.61,3.8a15.09,15.09,0,0,1,1.38-9.47,15.27,15.27,0,0,1,7-6.67A23.15,23.15,0,0,0,363.4,219.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,219.33c2.33,2.45,3.69,3.34,4.29,4.44,2,1.42,3.6,6.12,4.35,8.43C372.73,227.79,368.89,219.76,363.4,219.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.11,231.29c-.1.43.05.83.33.9s.59-.23.69-.66-.05-.83-.32-.89S368.22,230.86,368.11,231.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.64,230.81l-1-.18s0,0,0,0,0,.31,0,.46A.9.9,0,0,0,369.64,230.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.27,230.15c-.1.43.05.83.33.89s.59-.22.69-.65,0-.83-.33-.9S363.37,229.72,363.27,230.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,229.66l-1-.18s0,0,0,0l0,.46A.89.89,0,0,0,364.86,229.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.39,346.52c-11,13.38-37.09,37.6-37.09,37.6l-5-3.29s19.06-32.22,28.3-38.32c-7.78-12.35-33.1-56.26-33.1-56.26l18-6.52s20.37,39.09,29.82,57.48A8.51,8.51,0,0,1,308.39,346.52Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,289.66s16.06,44.12,22.13,62.59c5.35,16.35,21.53,56.43,21.53,56.43l5.77-2s-10.21-45.16-14.84-62C282.52,329.21,272,282.48,272,282.48Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,385.77c.87,4.67,1.51,5.34,3.89,9.47.52.89-1.78,2.05-3.42.23-2.73-3-2.76-3.12-5.08-5.66-2-2.2-4.37-4.62-6-6.34a1.09,1.09,0,0,1-.13-.17.87.87,0,0,1,.33-1.18l4.74-2.7a.52.52,0,0,1,.64.1l4.38,4.84A2.81,2.81,0,0,1,272.34,385.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,385.36h0c.5.84,1.49,2.26,2.33,2.36a.78.78,0,0,0,.73-.27.46.46,0,0,0,.12-.43c-.19-.8-2.7-1.77-3-1.87a.14.14,0,0,0-.15,0A.14.14,0,0,0,271.48,385.36Zm2.88,1.71v0a.14.14,0,0,1-.05.16.51.51,0,0,1-.45.18c-.49-.05-1.19-.74-1.91-1.84,1,.41,2.25,1.05,2.41,1.5Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,385.36a.1.1,0,0,0,.07.07c.73.32,2.64.51,3.07,0a.51.51,0,0,0-.06-.66,1.05,1.05,0,0,0-.71-.42,4.11,4.11,0,0,0-2.33.86.13.13,0,0,0,0,.13Zm2.93-.3a.15.15,0,0,1,0,.17c-.26.32-1.66.29-2.48,0a3.31,3.31,0,0,1,1.89-.64.72.72,0,0,1,.52.3A.39.39,0,0,1,274.41,385.06Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,250.26c-1.94-3.11-13.26-8.7-14.14-9.19l-3.13,7.27c4.51,2.62,11.17,6.24,10.77,8.79Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,241.78c-3.95-2.21-13.34-9-17.75-4.56,0,0-2.65,5.94,4,9.9,2.72,1.62,7.21,4.51,9,5.57Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278,241.78c-3.95-2.21-13.34-9-17.75-4.56,0,0-2.65,5.94,4,9.9,2.72,1.62,7.21,4.51,9,5.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Character--inject-452--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.08,406.2c1.64.76,5,1.06,9.33.69.95-.07,1.33,2.18-.86,2.85s-7,2-8.6,2.46c-2.57.79-4,1.41-6.07,2a.58.58,0,0,1-.18,0,.79.79,0,0,1-.86-.73l-.4-5a.47.47,0,0,1,.34-.49l6.35-2A1.41,1.41,0,0,1,302.08,406.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,242.16c.71-.33,1.44-.66,2.16-1A107.41,107.41,0,0,1,254.82,237q.78-.21,1.47-.36c1.68-.37,3.38-.66,5.08-.87a3.17,3.17,0,0,1,3.13,1.49c2.07,3.42,6.8,13.49,15.08,42.53l-27.44,9.9c-.86-2.06-2.47-8.39-5.25-16.52-1.19-3.47-2.59-7.25-4.25-11.18a122.83,122.83,0,0,0-8.25-16.31A72.58,72.58,0,0,1,241,242.16Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,242.16c.71-.33,1.44-.66,2.16-1A107.41,107.41,0,0,1,254.82,237q.78-.21,1.47-.36c1.68-.37,3.38-.66,5.08-.87a3.17,3.17,0,0,1,3.13,1.49c2.07,3.42,6.8,13.49,15.08,42.53l-27.44,9.9c-.86-2.06-2.47-8.39-5.25-16.52-1.19-3.47-2.59-7.25-4.25-11.18a122.83,122.83,0,0,0-8.25-16.31A72.58,72.58,0,0,1,241,242.16Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.47,253c1.55,3,2.93,6.05,4.18,9,.33.79.65,1.57,1,2.35a23,23,0,0,0,0-13.14Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,283.25s.39.19,8.55,31.26l11.65,23.86L308.45,331l-28.87-51.82Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.63,283.25s.39.19,8.55,31.26l11.65,23.86L308.45,331l-28.87-51.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287,332.52c-4.8-9.31-10.26-20.26-15-27.69l1.86-3.13C279.38,305.44,284.73,323,287,332.52Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,289.66l8.47,32.24c3.89,17.76,6.49,23.21,6.49,23.21l19.32-5.64-7.84-31.13c-4.23-15.41-6.59-25.86-6.59-25.86Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.16,289.66l8.47,32.24c3.89,17.76,6.49,23.21,6.49,23.21l19.32-5.64-7.84-31.13c-4.23-15.41-6.59-25.86-6.59-25.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.14,406.53a1.64,1.64,0,0,0,.92-.58.76.76,0,0,0,.05-.76.39.39,0,0,0-.32-.28c-.67-.12-2,1.43-2.19,1.61a.12.12,0,0,0,0,.14.13.13,0,0,0,.12.07A6.32,6.32,0,0,0,303.14,406.53Zm.44-1.32a.33.33,0,0,1,.16,0,.16.16,0,0,1,.12.12.5.5,0,0,1,0,.5,2.6,2.6,0,0,1-1.82.67,5.26,5.26,0,0,1,1.57-1.24Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75,406.75l.05,0c.45-.46,1.15-1.92.85-2.48a.41.41,0,0,0-.49-.2.72.72,0,0,0-.48.31,4,4,0,0,0-.1,2.3.14.14,0,0,0,.09.09Zm.4-2.43.06,0c.15-.05.2,0,.21.07.18.32-.22,1.39-.64,2a3.14,3.14,0,0,1,.12-1.82A.44.44,0,0,1,302.15,404.32Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.51,248.73c-.41,1-.73,1.91-1.06,2.86s-.63,1.88-.92,2.84c-.58,1.9-1.1,3.82-1.53,5.78a54.94,54.94,0,0,0-1.44,12.18c0,.1,0,.2,0,.31l0,.37a4.43,4.43,0,0,0,.09.72,7.84,7.84,0,0,0,.35,1.26l.22.56c.07.18.18.32.24.49l.25.48.27.42a17.72,17.72,0,0,0,2.26,2.78,35.64,35.64,0,0,0,4.84,4,64.22,64.22,0,0,0,10.45,5.88l2.05-3.54c-1.42-1.14-2.93-2.32-4.36-3.5s-2.85-2.39-4.17-3.63a35.59,35.59,0,0,1-3.59-3.77,10.26,10.26,0,0,1-1.18-1.79l-.09-.2-.05-.16,0-.17a.42.42,0,0,0,0-.1l0-.13h0l0-.06a50,50,0,0,1,.73-5.18c.35-1.75.74-3.52,1.22-5.27s1-3.51,1.53-5.26c.27-.88.55-1.75.85-2.62l.87-2.53Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,253c-1,6.67-2.63,13.74-2.63,13.74l-12.64-5.43s.9-13.26,5.54-15.66C240,242.76,245.24,245.75,244.12,253Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.12,253c-1,6.67-2.63,13.74-2.63,13.74l-12.64-5.43s.9-13.26,5.54-15.66C240,242.76,245.24,245.75,244.12,253Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.74,289.23c.8,2.45,5.53,1.47,5.53,1.47l.07-7-5,2.28Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.35 283.75 253.29 290.71 257.46 290.57 257.78 284.82 253.35 283.75",
    style: {
      fill: "#7f3e3b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,241.34l.57.37c.74.48,1.48,1,2.25,1.41h0a30.76,30.76,0,0,0,7.51,1.32,9.7,9.7,0,0,0,2.12-2.18,3.24,3.24,0,0,0-.11-1.69,2.13,2.13,0,0,0-.38-.69,4.25,4.25,0,0,1-2.65-1.46,2.58,2.58,0,0,1-.31-.45,7.75,7.75,0,0,1-.66-4.57l-8.34-5C245,231.84,246.74,238.6,243.71,241.34Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.38,232.51c.45,1.68,3.49,4.63,4.67,3.07a11.87,11.87,0,0,1,0-2.15l-4.94-3A5.8,5.8,0,0,0,247.38,232.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.82,223.2l.86,2.24s3.29,0,3.88-.4a4,4,0,0,1-.93-2.12c.07-.94,1.46-1.21,1.68-2.17s-.26-4-1.11-4.09-5.95.06-5.95.06C248.65,218.58,253.82,223.2,253.82,223.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,218a7.18,7.18,0,0,1,9.78-2.78c4.87,2.68,4.67,10.52,3,15.09-1.87,5.07-8.6,6.7-12.1,2.19-2.32-3-1.88-6.06-1.58-11.32A7.08,7.08,0,0,1,245,218Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.37,230.64l-.52-3.13,3.51,1.39s-1.72-4-1.4-5.85c.08-.93,1.08-1.23,1.32-2.19s-.27-4.06-1.12-4.1-5.14,0-5.14,0C237.42,218.61,244.37,230.64,244.37,230.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.46,223.19c.27,0,.46.4.41.83s-.31.75-.59.72-.47-.41-.42-.84S252.19,223.16,252.46,223.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,223.51c.28,0,.53.31.56.74s-.18.79-.46.81-.53-.32-.56-.75S256.65,223.52,256.93,223.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,228.15a2.49,2.49,0,0,0,2.08-.14,15.68,15.68,0,0,1-1.61-3.88Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.72,221.48h0a.25.25,0,0,1,0-.35,2.52,2.52,0,0,1,2.21-.63h0a.25.25,0,0,1,.17.31.26.26,0,0,1-.31.18,2,2,0,0,0-1.74.52.29.29,0,0,1-.22.06A.22.22,0,0,1,250.72,221.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,222a2,2,0,0,0-1.55-.94h0a.28.28,0,0,1-.22-.22.25.25,0,0,1,.22-.28,2.49,2.49,0,0,1,2,1.17v0a.23.23,0,0,1-.08.32.14.14,0,0,1-.11,0A.24.24,0,0,1,258.24,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.12,222.69c1.55.26,2.35,2.53,2.42,4,.08,1.66-1,2.87-2.38,1.94a5.26,5.26,0,0,1-2.13-3.12C240.64,224,241.58,222.43,243.12,222.69Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,230a14.22,14.22,0,0,0-.57,1.91l-.35,0c-1.59-.11-2.29-.69-2.58-1.29a2,2,0,0,1-.19-.95,1.84,1.84,0,0,1,.08-.55,7.65,7.65,0,0,0,3.07.86Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,230l-.18.55a4.73,4.73,0,0,1-3-.86,1.84,1.84,0,0,1,.08-.55A7.65,7.65,0,0,0,254.33,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,231.89c-1.59-.11-2.29-.69-2.58-1.29a5.26,5.26,0,0,1,1.74.47A1.9,1.9,0,0,1,254,231.89Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,219a35.75,35.75,0,0,0-18.19.82,4.13,4.13,0,0,1-3.24-4.34c.23-1.84,1.74-3.58,3.71-4.74a18.65,18.65,0,0,1,6.72-2.13c2.5-.37,5,.37,7.23,1.09s4.3,2,5.23,3.69A4.49,4.49,0,0,1,259,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,248.6l-18.54,9.53.05,3.91s19.32-3.81,21.51-6.8h0a5,5,0,0,0-1.72-5.68Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,258.13l-2.86,1.39a3.79,3.79,0,0,0-1.91,2.12l-1.3,3.55a.94.94,0,0,0,.42,1.12l2.23,1.21a.91.91,0,0,0,1.18-.28l2.29-3.21,2.29-3.69S267.34,257.59,266.24,258.13Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.6 261.63 267.99 261.95 266.01 257.65 267.46 256.98 269.6 261.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8,256.84h1.76a.9.9,0,0,1,.9.9v.13a0,0,0,0,1,0,0H264.9a0,0,0,0,1,0,0v-.13A.9.9,0,0,1,265.8,256.84Z",
    transform: "translate(-83.17 135.05) rotate(-24.71)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.29 184.48 191.41 187.38 184.71 179.98 179.84 174.6 179.83 174.6 179.83 174.59 184.86 171.31 189.33 176.96 195.29 184.48",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.58,183.29l-3.91,4a.49.49,0,0,0-.06.62l3.1,4.22a.93.93,0,0,0,1.32.15l.07-.06c7.62-6,9.55-9,10.28-9.83,2.1-2.28,0-3.62-.85-3.07-4,2.5-5.89,3.14-7.92,3.3A4.47,4.47,0,0,0,194.58,183.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.99 181.72 191.55 176.35 190.4 173.54 181.72 179.26 183.99 181.72",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.99 181.72 191.55 176.35 190.4 173.54 181.72 179.26 183.99 181.72",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,180.34c-.33,0-.73.47-1.09,1-.17.25-.34.51-.48.75s-.22.37-.3.53-.21.4-.23.45a.13.13,0,0,0,0,.16.1.1,0,0,0,0,0,.14.14,0,0,0,.11,0,10,10,0,0,0,1.62-.92,2.24,2.24,0,0,0,.67-.63l0,0a2.16,2.16,0,0,0,.24-.48.76.76,0,0,0-.2-.69A.42.42,0,0,0,198.28,180.34Zm.2.33a.49.49,0,0,1,.14.47,1,1,0,0,1-.25.45,2.63,2.63,0,0,1-.54.49,7.87,7.87,0,0,1-1,.61l-.25.13a7.74,7.74,0,0,1,.88-1.43c.19-.23.38-.46.59-.67a.53.53,0,0,1,.24-.11A.19.19,0,0,1,198.48,180.67Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,180.36a1,1,0,0,0-.24.77.79.79,0,0,0,0,.25,4,4,0,0,0,1.25,1.74l0,0a.14.14,0,0,0,.14,0,.13.13,0,0,0,.07,0,.08.08,0,0,0,0-.06,2.07,2.07,0,0,0,0-.46,4.44,4.44,0,0,0-.06-.87c-.09-.7-.32-1.39-.66-1.56C195.68,180.09,195.46,180.07,195.2,180.36Zm.5,0c.23.11.41.65.51,1.25a5.25,5.25,0,0,1,.06,1.1,4,4,0,0,1-1-1.31,1.13,1.13,0,0,1-.09-.35.77.77,0,0,1,.13-.49l0-.06C195.58,180.35,195.67,180.4,195.7,180.41Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,175.91l-1.5,1-.9.59-2.61,1.72-.5.33s-11.12-7.7-15.89-13c-3.26-3.64-3.44-4.86-3.87-4.62-5.68,3.28-20.17,14.61-35.71,16.32l-.86,0a26.1,26.1,0,0,1-11-2.68c.46-3.77,4.81-12.16,5.18-13l40-14.63c.21-.08.44-.13.66-.19s.57-.17.86-.23a10.63,10.63,0,0,1,3.27-.31,4.11,4.11,0,0,1,2.65.77C171.52,151.17,188.48,175.91,188.48,175.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.48,175.91l-1.5,1-.9.59-2.61,1.72-.5.33s-11.12-7.7-15.89-13c-3.26-3.64-3.44-4.86-3.87-4.62-5.68,3.28-20.17,14.61-35.71,16.32l-.86,0a26.1,26.1,0,0,1-11-2.68c.46-3.77,4.81-12.16,5.18-13l40-14.63c.21-.08.44-.13.66-.19s.57-.17.86-.23a10.63,10.63,0,0,1,3.27-.31,4.11,4.11,0,0,1,2.65.77C171.52,151.17,188.48,175.91,188.48,175.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,107.46c.79,3.71,1.62,9.13-1,11.66a83.3,83.3,0,0,0,11.2,15.5c5.65-9.67.4-15.7.4-15.7-4.18-.92-4.1-2.6-3.43-5.5Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,119.57a4.7,4.7,0,0,1,1.83-2.46c.84-.63,9.51-.67,11.76.08a5.67,5.67,0,0,1,3.13,2.5Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.15 184.86 200.02 181.68 188.77 167.35 183.19 170.59 196.15 184.86",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.23,175.26c-.52.16-1,1.24-1.37,2.12-.09.22-.16.42-.22.6h0l0,.1c-.07.21-.12.36-.13.42a.12.12,0,0,0,0,.16.14.14,0,0,0,.17,0,10.53,10.53,0,0,0,1.3-1l.27-.25a2.27,2.27,0,0,0,.66-1,1.85,1.85,0,0,0,.12-.4.8.8,0,0,0-.32-.7A.56.56,0,0,0,202.23,175.26Zm.28.33a.5.5,0,0,1,.22.47,1.64,1.64,0,0,1-.46.9,7.59,7.59,0,0,1-.9.86l-.48.37A1.69,1.69,0,0,1,201,178a1.09,1.09,0,0,1,.05-.17,7.68,7.68,0,0,1,1.07-2.07.53.53,0,0,1,.23-.16A.19.19,0,0,1,202.51,175.59Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,175.23a1.11,1.11,0,0,0-.14.85,4,4,0,0,0,1.73,1.9s0,0,0,0,0,0,0,0a.19.19,0,0,0,.15,0l.07-.06a.07.07,0,0,0,0-.06v0a2,2,0,0,0,0-.47c-.13-.93-.62-2.29-1.19-2.46C199.5,174.87,199.27,174.88,199.05,175.23Zm1.54,2.36A3.44,3.44,0,0,1,199.2,176a.78.78,0,0,1,.06-.54l0-.08c.15-.23.25-.2.28-.19C200,175.33,200.51,176.7,200.59,177.59Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.42,175.53l-4.77,5.18s-20.3-17.35-22.23-22.6c-1.28,1.5-19.53,20.44-42.25,23.34-.28,0-.56.06-.85.08a25.82,25.82,0,0,1-11.22-1.19c-7.24-2.7-9.22-9.09-8.69-14.52v0c.06-2.53.59-7.06.59-7.06l26.48.21c7.32-4.89,28.82-12.62,31.18-13.17.53-.12,1.05-.23,1.56-.3a14.47,14.47,0,0,1,1.58-.14h0a9.23,9.23,0,0,1,8.89,4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.77 181.49 196.84 174.46 195.12 171.69 186.93 179.28 189.77 181.49",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.77 181.49 196.84 174.46 195.12 171.69 186.93 179.28 189.77 181.49",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68,179l-3.87,5.12a.5.5,0,0,0,0,.66l3.89,4.07a1,1,0,0,0,1.42,0,.6.6,0,0,0,.08-.08c7.28-7.43,8.91-10.94,9.58-11.9,1.92-2.72-.47-3.85-1.33-3.14-3.88,3.21-5.49,3.67-7.63,4.11A5.09,5.09,0,0,0,198.68,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.41 145.64 162.3 150.23 133.01 149.49 148.13 145.53 178.41 145.64",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor-screen--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--PC--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "178.23 144.21 148.94 144.35 150.47 125.78 179.76 125.63 178.23 144.21",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.83,145.66,149,145.8a1.33,1.33,0,0,1-1.36-1.47l1.52-18.46a1.65,1.65,0,0,1,1.61-1.49l28.86-.14a1.33,1.33,0,0,1,1.36,1.47l-1.52,18.46A1.65,1.65,0,0,1,177.83,145.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.23 144.21 148.94 144.35 150.47 125.78 179.76 125.63 178.23 144.21",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.23 144.21 148.94 144.35 150.47 125.78 179.76 125.63 178.23 144.21",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.75 124.34 149.13 145.76 151.06 145.75 156.61 124.33 154.75 124.34",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.72 124.32 152.1 145.75 155.92 145.73 161.47 124.31 157.72 124.32",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "178.41 145.64 162.3 150.23 133.01 149.49 148.13 145.53 178.41 145.64",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.01 149.49 134.63 150.93 161.33 151.68 162.3 150.23 133.01 149.49",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.33 151.68 178.14 146.83 178.41 145.64 162.3 150.23 161.33 151.68",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,140.44h3.11l-1.78,4.26a8.78,8.78,0,0,1-3.19.34,1.88,1.88,0,0,1-1.22-3h0A4,4,0,0,1,145,140.44Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,143.11l-.83,1.48a1.2,1.2,0,0,1-1.29.59l-2.43-.5,1.78-4.26,2.22,1a1.18,1.18,0,0,1,.6,1.55A.93.93,0,0,1,150.81,143.11Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06,138.53a19.37,19.37,0,0,0,9.73,6.52c4.68,1.23,13.78.81,18.21-.21l0-3.45c-1.81-.39-18.25,1.14-24.13-9-1.1-1.88-5.3-9.49-7.59-10.4-3.72-1.49-5.13,2.47-4.28,4.76C109,129.48,114.11,136.15,116.06,138.53Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "148.74 140.77 148.72 140.77 148.73 140.76 148.74 140.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133,125.72c5,11.17-6.76,14.28-1.51,32.58l-25.49.44c.23-9.79,3.7-7.66-.77-26.1a17.82,17.82,0,0,1,.69-10.1,7.43,7.43,0,0,1,3.34-3.72c1.88-1,10.17-.15,13.95.12C127.31,118.39,132.26,124.32,133,125.72Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,125.72c5,11.17-6.76,14.28-1.51,32.58l-25.49.44c.23-9.79,3.7-7.66-.77-26.1a17.82,17.82,0,0,1,.69-10.1,7.43,7.43,0,0,1,3.34-3.72c1.88-1,10.17-.15,13.95.12C127.31,118.39,132.26,124.32,133,125.72Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.27,103.58c-.07.49.12.89.43.93s.61-.29.68-.76-.12-.89-.42-.93S128.34,103.12,128.27,103.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.82,102.82l1.17-.15S129.28,103.46,128.82,102.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35,104.22a12,12,0,0,0,1.22,3.23,2,2,0,0,1-1.72.06Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,100.32a.28.28,0,0,0,.17-.22.28.28,0,0,0-.23-.32,2.75,2.75,0,0,0-2.42.75.28.28,0,1,0,.37.41s0,0,0,0a2.2,2.2,0,0,1,1.93-.57A.23.23,0,0,0,130,100.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87,99.62c-.51,5.8-.86,8.25,1.59,11.64,3.69,5.1,10.94,4.48,13.18-1.05,2-5,2.53-13.63-2.74-16.77a8,8,0,0,0-12,6.18Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,109.86a3.34,3.34,0,0,1-1-1.43.12.12,0,0,1,.08-.15.13.13,0,0,1,.15.09,3.15,3.15,0,0,0,.81,1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.79,111a2.46,2.46,0,0,0-1.46,2.42l1.24-1.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86,111.07a2.44,2.44,0,0,0-.46,2.79l.51-2.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,93.77c-.25-1.1-2.08-.82-3.17-1.07a2.23,2.23,0,0,0-1.61,0,1.52,1.52,0,0,0-.64,1.38,4.91,4.91,0,0,0,.42,1.53,50.83,50.83,0,0,1,1.56,6,13.88,13.88,0,0,1,.15,4.33C126.11,105.69,130.15,100.1,128.72,93.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.69,93a14,14,0,0,0-11.43-1.5,11.21,11.21,0,0,0-7.53,8.45,13.36,13.36,0,0,0,1.14,7.38,39.17,39.17,0,0,0,3.84,6.51c-.2,2.42-2.28,4.38-3.7,6.35a11.58,11.58,0,0,0-2.4,7.12,7,7,0,0,0,3.9,6.12c.91.39.74,2.09.2,2.92A1.35,1.35,0,0,0,111,135c-.22.52-.47,1.32-.69,1.84a.82.82,0,0,1,.69-.37,4.35,4.35,0,0,0,.81,0,2.17,2.17,0,0,0,1.18-1.11,8.91,8.91,0,0,0,1.76-4.44,3.49,3.49,0,0,0-.66-2.17c.37-.36.9-.2,1.32.1a2.39,2.39,0,0,1,.8,1.29,5.87,5.87,0,0,1,.24,2c2-2.84,2.07-7.35.61-10.48-.48-1.05-1.18-2.19-.79-3.28.46-1.3,0-2.87.94-3.89,2.3-.17,3.77-2.32,4.88-4.35A31.7,31.7,0,0,0,125.69,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,103.63a5.08,5.08,0,0,0,1.29,3.66c1.2,1.32,2.74.47,3.2-1.16.41-1.46.27-3.91-1.31-4.62A2.27,2.27,0,0,0,120.38,103.63Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78,156.8l-.6,2.3c-.09.19.13.36.42.35l26.25-.45c.23,0,.42-.12.43-.26l-.64-2.43c0-.16-.19-.29-.44-.28l-25,.57A.48.48,0,0,0,105.78,156.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.12,159.26l-.69.07c-.14,0-.25,0-.25-.13v-3c0-.09.12-.17.25-.19l.69-.07c.14,0,.25,0,.25.13v3C129.36,159.17,129.25,159.25,129.12,159.26Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,159.32l-.69.07c-.13,0-.24,0-.25-.13l0-3c0-.09.11-.17.25-.19l.68-.07c.14,0,.25,0,.25.13v3C120,159.24,119.86,159.31,119.72,159.32Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,159.32l-.69.07c-.13,0-.24,0-.25-.13l0-3c0-.09.11-.17.25-.19l.68-.07c.14,0,.25,0,.25.13v3C120,159.24,119.86,159.31,119.72,159.32Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,126.19s-1.39,2.79,2.53,10.23l1.64,3h0c.54,1,4.2-1,5.3-2.87h0S124.54,132.36,122,126.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,140.59l2.88.15-1.83,3.89s-4.5,1.16-5-1.61l1-1.13A3.72,3.72,0,0,1,158.85,140.59Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,143.38l-.84,1.34a1.13,1.13,0,0,1-1.23.49l-2.23-.59,1.84-3.89,2,1.08a1.09,1.09,0,0,1,.49,1.48Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54,142.19c1.91,2.63,4.57,5.09,7.8,5.48,2.5.31,14.37-1.54,16.11-3.18V141.7s-12.41.06-14-.11c-2.32-.23-3.78-1.82-5.74-5.22-1-1.69-4.14-8.64-5.34-10.19-1.92-2.49-7.45-.75-5.3,5.22C127,133.91,131,140,132.54,142.19Z",
    style: {
      fill: "#cb7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,122.06c3.9,3.62,5.76,10,5.76,10l-9.18,5.52s-6.63-9.43-5.41-12.69c1-2.53,2.71-4.18,5-4.31A5.24,5.24,0,0,1,130.6,122.06Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39,159.62h-.69c-.14,0-.25-.07-.24-.16l.27-3c0-.09.13-.17.27-.17h.69c.14,0,.25.07.24.15l-.28,3A.23.23,0,0,1,109.39,159.62Z",
    style: {
      fill: "#B5D0FF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.39,375.29l5,3.44,4.06-4.87-3.84-.39a13.65,13.65,0,0,1-2.76-.56h0Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,373.86l-5,4.23,2.94,2.35a.82.82,0,0,0,1.08-.12L154,377a.42.42,0,0,0,0-.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.13,348.39l-2.8,11.93,15.51,13-1.67,2.88s-17.15-7.72-19.6-12,2.72-20.07,2.72-20.07Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1,342c2.14,1.06,7.16,4.75,2.86,17.32L123,358.07C124.13,350.21,125.72,341,129.1,342Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1,342c2.14,1.06,7.16,4.75,2.86,17.32L123,358.07C124.13,350.21,125.72,341,129.1,342Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06,378.71l-1,4.07s-9.9-3-13.22,5.34,5.33,26.06,31.66,19.92c0,0,7.1,1.92,13.17.39,9-2.26,20.45-7.54,21.69-15.9,2.07-14-25.77-9-25.77-9l-1-2.62Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57,384.58s6.23,3.15,8.49,8.43l2.69,1S114.17,386.79,104.57,384.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.77,397.94s.19-8.95,9.09-15.81h6.92l-13.36,17.49Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,388.8S84.11,396,93.67,404s14.71-2.66,14.71-2.66l.74-4.07-6.54-5.85-8.31-5.61-4.54.54Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,389.8a19,19,0,0,0,10.7,14.61c8.21,3.91,10.32-7.16,10.32-7.16l-15.14-9.86-5.59.73Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,389.8a19,19,0,0,0,10.7,14.61c8.21,3.91,10.32-7.16,10.32-7.16l-15.14-9.86-5.59.73Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,416.08a14.72,14.72,0,0,0-7.75-6.71,2.12,2.12,0,0,1-.85-.77,1.94,1.94,0,0,1-.22-.4l-1.69-5.52a.48.48,0,0,1,0-.31.54.54,0,0,1,.21-.36l4.73-2.74a.92.92,0,0,1,1.29.19l.1.17c.95,2.29,1.71,4.37,3,7.2,1.46,3.34,1.49,2.32,3.26,6.22C155.12,415.41,152.62,417,152,416.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,383.08s23.8-5.17,27.6,2.39-9.7,12.6-14.5,14.3c-8.37,3-37.4,12.07-37.4,12.07l1.89-5.92L126.62,398S127.25,390.1,135.18,383.08Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82,411.1l2.07-6.25a.53.53,0,0,0-.23-.62L110,401.42a.88.88,0,0,0-1.21.3.6.6,0,0,0-.08.16c-.71,2.27-1.25,4.31-2.18,7.12-1.1,3.31-1.21,2.34-2.56,6.21-.8,2.33,1.72,3.64,2.18,2.69,2.08-4.36,3.61-4.38,5.82-5.59A2.11,2.11,0,0,0,112.82,411.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.84,385.28c-.23-.88-13.42,7.52-17.53,7A23,23,0,0,0,127,396h0l-.16.67a.36.36,0,0,1,0,.1c0,.07,0,.15,0,.22a.5.5,0,0,0,0,.12,1,1,0,0,0,0,.17s0,.08,0,.12l0,.13v.1s0,.07,0,.1a.28.28,0,0,1,0,.09V398h0v0l-13,7.39,10.18,2.32c6.07-1.93,13.11-4.19,18.45-5.95l-13.48-5.08C133.84,393.61,146,386,145.84,385.28Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,408.6c-7.37-.93-21.35-2.76-26.17-3.8-8.69-1.88-37.35-9.24-30.06-19,7.61-10.2,22.84,5.3,22.84,5.3l31.45,11.28a.48.48,0,0,0,0,.31l1.69,5.52A1.94,1.94,0,0,0,143.44,408.6Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.92,385.36c-2.27,1,12.13,5.72,12.13,5.72a43.94,43.94,0,0,0-6.14-5C101.69,385.21,99.44,384.7,97.92,385.36Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.22,339.15l-6-1.42-7.61-.05a5.27,5.27,0,0,0-5.12,3.85A136.15,136.15,0,0,0,100.41,358c-.85,6.24.2,13.39.43,21.85l27.15,1c-1.44-12.36,1-23.17,2.63-29.68.35-4,0-8.74-2.14-9.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41,358c.59-4.38,1.38-9.32,2.31-13.42,5-1.05,7.92,9.94,6.64,15.5s-9.42,2.55-9.42,2.55C100.07,361,100.22,359.4,100.41,358Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,334a4,4,0,0,0,4.19.82,4.5,4.5,0,0,1-2.4,1.47,4.86,4.86,0,0,0,5.29-.14c-.58.54-1.36,1.24-1.93,1.78a10,10,0,0,0,12.48-10.17c-.07-1.35-2.06-2-3.32-2.48a7.75,7.75,0,0,0-3.94-.37,14.88,14.88,0,0,0-3.07,1C116.15,325.69,115.75,333,108.79,334Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18,328l2.44,3.42,3.32,4.65a4.76,4.76,0,0,0-.9,1.45c-.51,1.18-1,2.06,1.52,3.61a1.63,1.63,0,0,1,.79,1.55c-.12.76-.83,1.51-3.46,1.16a12,12,0,0,1-6.69-3.37c-.91-.83-.74-1.5.06-2.43C117.55,335.39,118.1,331.29,118.18,328Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.15,334.92l-2.06-3.33-.12.29a10.18,10.18,0,0,0-.36,1.31c-.29,1.53,1,3.64,2.31,4.62l.14-.3a5.75,5.75,0,0,1,.83-1.39.19.19,0,0,1,.07-.06Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.44,328.22c2.81-4.11,2.64-6.66,5.11-8.73,1.23-.37,3,2,1.18,5.52S127.44,328.22,127.44,328.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,322.2c-.9,5.06-1.65,8,.27,11.09,2.9,4.69,9.63,3.76,12-1,2.14-4.25,3.22-11.82-1.22-14.89A7.13,7.13,0,0,0,119,322.2Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81,326.65l2.55,2,.92-4.42,2.43-1,3.27-3.78s-5.75-2.51-7.51-3c-.61-.16-3,1.26-3.43,1.93a5.9,5.9,0,0,0,.2,6.21A13,13,0,0,0,117.81,326.65Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,325.55a4.71,4.71,0,0,0,1.18,3.12c1,1.1,2.43.13,2.73-1.3s-.22-3.23-1.5-3.79S116,324.11,116,325.55Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,326c-.11.41,0,.81.27.9s.55-.18.69-.59a.68.68,0,0,0-.27-.9C126.77,325.3,126.47,325.56,126.35,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,327.46c-.12.41,0,.82.27.9s.58-.18.69-.58,0-.82-.26-.9S131.08,327.05,131,327.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,327.29a13.92,13.92,0,0,0,.56,3.57,2,2,0,0,1-1.73-.33Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.18,332.83a3.66,3.66,0,0,1-2.24-1.82.13.13,0,1,1,.23-.11,3.52,3.52,0,0,0,2.54,1.8.13.13,0,0,1,.12.14.12.12,0,0,1-.14.11h0A4.37,4.37,0,0,1,127.18,332.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.87,324.23a.16.16,0,0,1-.1-.08.25.25,0,0,1,.06-.35,2.39,2.39,0,0,1,2.25-.32.25.25,0,0,1,.14.32h0a.25.25,0,0,1-.33.13,1.94,1.94,0,0,0-1.76.27A.21.21,0,0,1,125.87,324.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75,324.79a.24.24,0,0,1,0-.12.26.26,0,0,1,.33-.15,2.38,2.38,0,0,1,1.54,1.66.25.25,0,0,1-.49.11,1.91,1.91,0,0,0-1.23-1.3A.26.26,0,0,1,131.75,324.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.92,383.26l-16.61-1.61s-.06-.32,1.37-.39l.38,0c.28,0,1.41-.09,2.92-.16l.49,0c4.34-.2,11.2-.49,11.2-.49l.21,2.25Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,382.81l-12.48-1.26s-.5-.36.58-.47l.49,0c4.34-.2,11.2-.49,11.2-.49Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,376.27l2.5.64L121.25,382s-5.27-1.65-4.3-4l1.28-.8C119.32,376.6,120.72,375.87,122.06,376.27Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.89 380.26 124.51 382.83 121.25 382.04 124.56 376.91 126.89 380.26",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62,355.41c-1.55,4.72-3.23,5.34-1.33,7.82S119,374.16,121,376.66l-3.38,2.58q-6-3.32-12-6.49c-2.94-1.54-6.07-3.23-7.61-6.18-2.2-4.22-1-8.26,1.5-13.72C101.87,352.44,107.62,355.41,107.62,355.41Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92,337.8c5.32-1,8.14,3.46,5.9,10.42a46.41,46.41,0,0,1-3.62,9.24l-12.58-2.92C98.44,347.67,101.48,338.86,106.92,337.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.32,384.1l30.09-1.22a.63.63,0,0,0,.6-.58h0a.51.51,0,0,0-.54-.54L126.37,383a.63.63,0,0,0-.59.59h0A.51.51,0,0,0,126.32,384.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,382.62l14.23,1.47a.62.62,0,0,0,.66-.51h0a.51.51,0,0,0-.45-.62l-14.23-1.46a.61.61,0,0,0-.66.5h0A.51.51,0,0,0,111.86,382.62Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,382.62l14.23,1.47a.62.62,0,0,0,.66-.51h0a.51.51,0,0,0-.45-.62l-14.23-1.46a.61.61,0,0,0-.66.5h0A.51.51,0,0,0,111.86,382.62Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,382.94l28.07-1.14a2.24,2.24,0,0,0,2-1.87l1.91-14.21a1.47,1.47,0,0,0-1.56-1.73l-28.07,1.14a2.23,2.23,0,0,0-2,1.87l-1.91,14.21A1.47,1.47,0,0,0,127.19,382.94Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,382.94l28.07-1.14a2.24,2.24,0,0,0,2-1.87l1.91-14.21a1.47,1.47,0,0,0-1.56-1.73l-28.07,1.14a2.23,2.23,0,0,0-2,1.87l-1.91,14.21A1.47,1.47,0,0,0,127.19,382.94Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,382.84l28.06-1.13a2.25,2.25,0,0,0,2-1.87l1.9-14.21a1.47,1.47,0,0,0-1.56-1.73L130.41,365a2.24,2.24,0,0,0-2,1.88l-1.91,14.21A1.47,1.47,0,0,0,128,382.84Z",
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,382.84l28.06-1.13a2.25,2.25,0,0,0,2-1.87l1.9-14.21a1.47,1.47,0,0,0-1.56-1.73L130.41,365a2.24,2.24,0,0,0-2,1.88l-1.91,14.21A1.47,1.47,0,0,0,128,382.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72,311.68a4,4,0,0,0-1,3.2c.13.65,1-.87,1.18-.23.29,1.33-.26,2.67-.53,4a9.92,9.92,0,0,0,1.64,7.68l-.18-.19a29.7,29.7,0,0,1,9.94-4.3c1.47-.39,3.08-.9,4.53-.41,3.31,1.11,3.39,3.58,3.39,3.58,2.23-4-.32-9.92-3.36-13.28S115.44,310.78,114.72,311.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,318.27c.12.91.09,1.58.21,2.48a6.18,6.18,0,0,0-4.88-1.45,3.27,3.27,0,0,0-.33-2A5.94,5.94,0,0,1,132.31,318.27Z",
    style: {
      fill: "#B5D0FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-speech-bubbles-inject-120--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.15,138.65l71.89-.43a3.78,3.78,0,0,1,3.93,3.63,4.24,4.24,0,0,1,0,.62l-3.53,33.06a5,5,0,0,1-4.81,4.31l-29.91.33a32.46,32.46,0,0,1-18.95,11.06s6.89-6.31,8.51-11l-31.54,0a3.78,3.78,0,0,1-3.92-3.63,4.24,4.24,0,0,1,0-.62L251.34,143A5,5,0,0,1,256.15,138.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.23,192l1.18-1.09c.07-.05,6.18-5.69,8.12-10.13l-30.8,0a4.2,4.2,0,0,1-3.06-1.13,4.31,4.31,0,0,1-1.34-3.69l3.51-33a5.46,5.46,0,0,1,5.3-4.76h0l71.89-.43a4.27,4.27,0,0,1,4.43,4.11,4.22,4.22,0,0,1,0,.71l-3.52,33.05a5.45,5.45,0,0,1-5.3,4.75l-29.68.32a33.34,33.34,0,0,1-19.12,11.07ZM284,179.73l-.23.67c-1.23,3.55-5.29,7.91-7.38,10a32.14,32.14,0,0,0,17-10.54l.15-.18,30.14-.33a4.46,4.46,0,0,0,4.33-3.87l3.52-33.05a3.41,3.41,0,0,0,0-.55,3.28,3.28,0,0,0-3.41-3.15l-71.9.43a4.47,4.47,0,0,0-4.33,3.88l-3.51,33a5.21,5.21,0,0,0,0,.55,3.3,3.3,0,0,0,3.42,3.15Z",
    style: {
      fill: "#B5D0FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.33,
    y: 145.38,
    width: 32.42,
    height: 1,
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.82,
    y: 154.02,
    width: 17.76,
    height: 1,
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.91,
    y: 154.02,
    width: 18.09,
    height: 1,
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.82,
    y: 162.67,
    width: 45.13,
    height: 1,
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.1,
    y: 171.32,
    width: 11.72,
    height: 1,
    style: {
      fill: "#B5D0FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.99, 0, -0.17, 0.99, 297.73, 175.15)",
    style: {
      fontSize: "46.76708984375px",
      fill: "#B5D0FF",
      fontFamily: "Montserrat-ExtraBold, Montserrat",
      fontWeight: 800,
      letterSpacing: "-0.005002905170894549em"
    }
  }, "?")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/Bg.cb309e920c9c07ab22e7dd2f957a3eb1.svg";
export { ForwardRef as ReactComponent };